import { useEffect, useRef } from "react";
import { Loader2 } from "lucide-react";
import { DiscussionMessage } from "./DiscussionMessage";
import type { DiscussionMessage as DiscussionMessageType } from "@/types";

interface DiscussionThreadProps {
  messages: DiscussionMessageType[];
  isLoading: boolean;
  currentUserId: string;
}

export function DiscussionThread({
  messages,
  isLoading,
  currentUserId,
}: DiscussionThreadProps) {
  const messagesEndRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  return (
    <div className="relative flex min-h-0 flex-1 flex-col">
      <div className="flex-1 space-y-4 overflow-y-auto p-4">
        {isLoading && messages.length === 0 ? (
          <div className="flex items-center justify-center py-12">
            <Loader2 className="h-6 w-6 animate-spin text-slate-400" />
          </div>
        ) : (
          messages.map((message) => (
            <DiscussionMessage
              key={message.id}
              message={message}
              isOwnMessage={message.user_id === currentUserId}
            />
          ))
        )}
        <div ref={messagesEndRef} />
      </div>
    </div>
  );
}
